<template>
    <div>
        <Nav></Nav>
        <PageHeader :linkto="'/Lover'" :linkttitle="'返回'" :title="productName"></PageHeader>
        <AnaLoading way="Client" :show="pageloading"></AnaLoading>
        <div v-if="!pageloading">
        <b-container v-if="pageview" class="resultContainer">
            <CompareCard coverType="love" starType="love" :mainName="mainName" :secName="secName" :listdata="anaResult.Icon.explantion"> </CompareCard>
            <NameCard :data="anaResult.Basic"></NameCard>
            <SwitchResultCard title="的個性分析" :mainName="mainName" :secName="secName" :Alistdata="anaResult.Apersonality.explantion" :resultname="'result'" :Blistdata="anaResult.Bpersonality.explantion"></SwitchResultCard>
            <WhoIsWin title="誰佔上風" :secName="secName" :mainName="mainName" :data="anaResult.Leader" ></WhoIsWin>
            <SwitchResultCard title="相處建議" :mainName="mainName" :secName="secName" :Alistdata="anaResult.Aadvice.explantion" :resultname="'advice'" :Blistdata="anaResult.Badvice.explantion"></SwitchResultCard>
            <SwitchAllyearCard title="流年運勢" :mainName="mainName" :secName="secName" :Alistdata="anaResult.AAllyear" :resultname="'advice'" :Blistdata="anaResult.BAllyear"></SwitchAllyearCard>
            <SwitchPlusClothCard title="加分穿搭"
                                 :mainName="mainName"
                                 :secName="secName"
                                 :Alistdata="anaResult.Aoutfit.explantion"
                                 :Blistdata="anaResult.Boutfit.explantion"
                                 :Acolor="anaResult.Aoutfit.Color"
                                 :Bcolor="anaResult.Boutfit.Color"
            ></SwitchPlusClothCard>

            <MediaBanner></MediaBanner>
        </b-container>
        <b-container v-else>
            <b-button class="mt-3" variant="primary" block to="/Lover">返回{{ productName }}</b-button>
            <b-button class="mt-3" variant="primary" block to="/HistoryLog/6">返回歷史紀錄</b-button>
        </b-container>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import Nav from '@/components/Nav.vue'
import PageHeader from '@/components/PageHeader.vue'
import NameCard from '@/components/NameCard.vue'
import CompareCard from '@/components/CompareCard.vue'
import SwitchResultCard from '@/components/SwitchResultCard.vue'
import SwitchPlusClothCard from '@/components/SwitchPlusClothCard.vue'
import WhoIsWin from '@/components/WhoIsWin.vue'
import SwitchAllyearCard from '@/components/SwitchAllyearCard.vue'
import {playSound} from '@/service/commuse'
import AnaLoading from '@/components/AnaLoading.vue'
import MediaBanner from '@/components/MediaBanner.vue'


export default {
  name: 'LoverResult',
  components: {Nav,PageHeader,NameCard,CompareCard,SwitchResultCard,SwitchAllyearCard,SwitchPlusClothCard,WhoIsWin,MediaBanner,AnaLoading},
  data () {
    return {
      productName:'感情雙方比對',
      pageloading:true,
    }
  },
  computed:{
    ...mapState(['anaResult']),
    pageview:function () {return Object.keys(this.anaResult).length === 0 ? false: true;},
    mainName:function () {return Object.keys(this.anaResult).length === 0 ? '': this.anaResult.Basic.mainname.oname;},
    secName:function () {return Object.keys(this.anaResult).length === 0 ? '': this.anaResult.Basic.secname.oname;},
  },
  mounted(){
    this.loadingView()
  },
  methods: {

    loadingView(){
      setTimeout(()=>{
        if(this.pageview){
          playSound()
        }
        this.pageloading = false
      },2500)


    }

  }
}
</script>

<style scoped>

</style>
